import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PagedResponse } from '../../../shared/contract/paged-response.contract';
import { getHttpParameters } from '../../../shared/utils/get-http-parameters';
import {
  ActiveLocation,
  ActiveLocationsSummaryView,
  SearchActiveLocationsFiltersRequest,
  SearchActiveLocationsRequest,
  SearchActiveLocationsSummaryRequest,
} from '../active-locations/contract/active-location.contract';
import { ActiveLocationsFilterCollectionView } from '../active-locations/contract/active-locations-filter-collection-view.contract';

@Injectable({ providedIn: 'root' })
export class LocationsApiService {
  private readonly url = environment.APP_DISPOSITION_SERVICE_BASE_URL + '/api/v1/locations';

  private readonly http = inject(HttpClient);

  getActiveLocations(request: SearchActiveLocationsRequest): Observable<PagedResponse<ActiveLocation>> {
    const params = getHttpParameters({
      page: request.page,
      size: request.size,
      sort: request.sort,
      term: request.term,
      searchColumns: request.searchColumns,
      types: request.types,
      categories: request.categories,
      costCenters: request.costCenters,
      organisations: request.organisations,
      labels: request.labels,
      matchAllLabels: request.matchAllLabels,
    });

    return this.http.get<PagedResponse<ActiveLocation>>(this.url, { params });
  }

  getActiveLocationsFilters(
    request: SearchActiveLocationsFiltersRequest,
  ): Observable<ActiveLocationsFilterCollectionView> {
    const params = getHttpParameters({
      term: request.term,
      searchColumns: request.searchColumns,
      types: request.types,
      categories: request.categories,
      costCenters: request.costCenters,
      organisations: request.organisations,
      labels: request.labels,
      matchAllLabels: request.matchAllLabels,
    });

    return this.http.get<ActiveLocationsFilterCollectionView>(`${this.url}/filters`, { params });
  }

  getActiveLocationsSummary(request: SearchActiveLocationsSummaryRequest): Observable<ActiveLocationsSummaryView> {
    const { term, searchColumns, ...filters } = request;
    const params = getHttpParameters({
      term,
      searchColumns,
      ...filters,
    });

    return this.http.get<ActiveLocationsSummaryView>(`${this.url}/search/data-summary`, { params });
  }
}
